<template>
  <v-container fluid>
    <v-row>
      <!-- Desktop sidebar -->
      <v-col cols="12" md="3" class="d-none d-md-block">
        <v-list nav dense>
          <v-list-item-group v-model="selected" color="primary">
            <v-list-item
              v-for="item in menuItems"
              :key="item.route"
              :to="item.route"
              router
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <!-- Mobile dropdown -->
      <v-col cols="12" class="d-md-none">
        <v-select
          :items="menuItems"
          item-text="title"
          item-value="route"
          v-model="currentRoute"
          label="Select Report"
          dense
          outlined
          @change="navigateToReport"
        />
      </v-col>
      <v-col cols="12" md="9">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selected: 0,
      currentRoute: "",
      menuItems: [
        {
          title: "1. Closed Files by Department",
          route: "/compliance/closed-files",
          icon: "mdi-folder-check",
        },
        {
          title: "2. Compliance Ratio (By Insurer)",
          route: "/compliance/compliance-ratio-dept-insurer",
          icon: "mdi-chart-bar",
        },
        {
          title: "3. Compliance Ratio (By Branch)",
          route: "/compliance/compliance-ratio-branch",
          icon: "mdi-chart-bar",
        },
        {
          title: "4. Outstanding Assignment (By Insurer)",
          route: "/compliance/outstanding-insurer",
          icon: "mdi-alert-circle",
        },
        {
          title: "5. Outstanding Assignment (By Branch)",
          route: "/compliance/outstanding-branch",
          icon: "mdi-alert-circle",
        },
        {
          title: "6. Outstanding Assignment by Days (Insurer)",
          route: "/compliance/outstanding-days-insurer",
          icon: "mdi-calendar-clock",
        },
        {
          title: "7. Outstanding Assignment by Days (Branch)",
          route: "/compliance/outstanding-days-branch",
          icon: "mdi-calendar-clock",
        },
        {
          title: "8. Ratio Calculator by Closed Files (Insurer)",
          route: "/compliance/ratio-calculator-insurer",
          icon: "mdi-calculator",
        },
        {
          title: "9. Compliance Table",
          route: "/compliance/compliance-table",
          icon: "mdi-table",
        },
        {
          title: "10. Outstanding Master List",
          route: "/compliance/outstanding-master",
          icon: "mdi-format-list-bulleted",
        },
        {
          title: "11. Closed by Adjuster (By Date)",
          route: "/compliance/closed-by-adjuster-date",
          icon: "mdi-account-tie",
        },
        {
          title: "12. Closed by Adjuster (By Month)",
          route: "/compliance/closed-by-adjuster-month",
          icon: "mdi-account-tie",
        },
        {
          title: "13. Closed by Clerk (By Date)",
          route: "/compliance/closed-by-clerk-date",
          icon: "mdi-account",
        },
        {
          title: "14. Closed by Clerk (By Month)",
          route: "/compliance/closed-by-clerk-month",
          icon: "mdi-account",
        },
        {
          title: "15. Outstanding By Adjuster (By Date)",
          route: "/compliance/outstanding-by-adjuster-date",
          icon: "mdi-account-clock",
        },
        {
          title: "16. Received by Days (Insurer)",
          route: "/compliance/received-days-insurer",
          icon: "mdi-calendar-import",
        },
        {
          title: "17. Received by Month (Insurer)",
          route: "/compliance/received-month-insurer",
          icon: "mdi-calendar-month",
        },
      ],
    };
  },
  computed: {
    currentReportTitle() {
      // Support both parent and child compliance routes
      const routePath = this.$route.path;
      // Try exact match first
      let found = this.menuItems.find((item) => item.route === routePath);
      if (found) return found.title;
      // Try matching child route (for nested compliance routes)
      found = this.menuItems.find((item) =>
        routePath.endsWith(item.route.replace("/compliance", ""))
      );
      return found ? found.title : "Compliance";
    },
    isClosedFilesReport() {
      return (
        this.$route.path === "/compliance/closed-files",
        "/compliance/compliance-ratio-insurer"
      );
    },
  },
  watch: {
    "$route.path"(val) {
      this.currentRoute = val;
    },
  },
  methods: {
    navigateToReport(route) {
      if (route && route !== this.$route.path) {
        this.$router.push(route);
      }
    },
  },
  mounted() {
    this.currentRoute = this.$route.path;
  },
};
</script>
